const chainReaderAddressMap: Record<string, Record<string, string>> = {
    'bnb': {
        'UniswapV3': '0x20AB9aFc7b0446EB21132fa7D7CD147BeF60240f',
        'PancakeSwapV3': '0x20AB9aFc7b0446EB21132fa7D7CD147BeF60240f',
        'UniswapV4': '0x77134eD4aCaDD5921B247f18C7d4ADE49a9a352d',
        'PancakeInfCl': '0x77134eD4aCaDD5921B247f18C7d4ADE49a9a352d',
    },
    'eth': {
        'UniswapV3': '0x32Cc2420551f068e4d349F5cA72D24dB6C180024',
        'PancakeSwapV3': '0x32Cc2420551f068e4d349F5cA72D24dB6C180024',
        'UniswapV4': '0xFc89014Ed7357A9A289b479f29923e857cD4cBe0'
    },
    'base': {
        'UniswapV3': '0xC4CC86b98c17d422573d8e530124EBd8A218Ba09',
        'PancakeSwapV3': '0xC4CC86b98c17d422573d8e530124EBd8A218Ba09',
        'UniswapV4': '0xBf348430b736cD4296Da097aC897fb910B941E63',
        'PancakeInfCl': '0xBf348430b736cD4296Da097aC897fb910B941E63',
        'AerodromeV3': '0xC4CC86b98c17d422573d8e530124EBd8A218Ba09',
    },
    'arbitrum': {
        'UniswapV3': '0x4e08B91F0A49Ba0E28F7027e7372BD6cC99513EB',
        'PancakeSwapV3': '0x4e08B91F0A49Ba0E28F7027e7372BD6cC99513EB',
        'UniswapV4': '0x69c5f91e06370f8165c1Bc68410A494185fb60f8',
    },
}

export default {
    getNodeUrl: function (chain: string) {
        switch (chain) {
            case 'bnb':
                return 'https://bsc-rpc.publicnode.com'
            case 'eth':
                return 'https://ethereum-rpc.publicnode.com'
            case 'base':
                return 'https://base-rpc.publicnode.com'
            case 'arbitrum':
                return 'https://arbitrum-one-rpc.publicnode.com'
            default:
                throw new Error('Unsupported chain');
        }
    },
    getReaderAddress: function (chain: string, protocol: string): string {
        return chainReaderAddressMap[chain][protocol];
    },
    formatTick: function (tick: number, tickSpace: number) {
        return Math.floor(tick / tickSpace) * tickSpace;
    },
}